import { useEffect } from "react";
import { useSortBy, UseSortByProps } from "react-instantsearch"

interface VirtualSortByProps extends UseSortByProps {
  sortBy: string;
}

export function VirtualSortBy(props:VirtualSortByProps) {
  const {refine, currentRefinement } = useSortBy(props);
  useEffect(() => {    
    if (props.sortBy != '' && currentRefinement != props.sortBy) refine(props.sortBy);
  },[props.sortBy]);
  return null;
}
